function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "log-out"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 6a1 1 0 000-2H5a1 1 0 00-1 1v14a1 1 0 001 1h2a1 1 0 000-2H6V6zM20.82 11.42l-2.82-4a1 1 0 00-1.39-.24 1 1 0 00-.24 1.4L18.09 11H10a1 1 0 000 2h8l-1.8 2.4a1 1 0 00.2 1.4 1 1 0 00.6.2 1 1 0 00.8-.4l3-4a1 1 0 00.02-1.18z"
})));

function SvgIconLogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBkYXRhLW5hbWU9ImxvZy1vdXQiPjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgMTIgMTIpIiBvcGFjaXR5PSIwIi8+PHBhdGggZD0iTTcgNmExIDEgMCAwIDAgMC0ySDVhMSAxIDAgMCAwLTEgMXYxNGExIDEgMCAwIDAgMSAxaDJhMSAxIDAgMCAwIDAtMkg2VjZ6Ii8+PHBhdGggZD0iTTIwLjgyIDExLjQybC0yLjgyLTRhMSAxIDAgMCAwLTEuMzktLjI0IDEgMSAwIDAgMC0uMjQgMS40TDE4LjA5IDExSDEwYTEgMSAwIDAgMCAwIDJoOGwtMS44IDIuNGExIDEgMCAwIDAgLjIgMS40IDEgMSAwIDAgMCAuNi4yIDEgMSAwIDAgMCAuOC0uNGwzLTRhMSAxIDAgMCAwIC4wMi0xLjE4eiIvPjwvZz48L2c+PC9zdmc+";
export { SvgIconLogOut as ReactComponent };